import React, { useMemo } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { HelmetProvider } from 'react-helmet-async';
import { setupGlobalErrorListeners } from './services/logger';
import { setupStaleChunkRecovery } from './utils/staleChunkRecovery';
import App from './App';
import ScrollToTop from './components/layout/ScrollToTop';
import { getAppTheme } from './theme/theme';
import { ThemeModeProvider, useThemeMode } from './contexts/ThemeModeContext';
import './index.css';

setupGlobalErrorListeners();
setupStaleChunkRecovery();

const AppWithTheme = () => {
    const { resolvedMode } = useThemeMode();
    const dynamicTheme = useMemo(() => getAppTheme(resolvedMode), [resolvedMode]);

    return (
        <ThemeProvider theme={dynamicTheme}>
            <CssBaseline />
            <App />
        </ThemeProvider>
    );
};

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <HelmetProvider>
            <BrowserRouter>
                <ScrollToTop />
                <ThemeModeProvider>
                    <AppWithTheme />
                </ThemeModeProvider>
            </BrowserRouter>
        </HelmetProvider>
    </React.StrictMode>
);